import axios from '@/plugins/axios'

const state = {
  users: [],
  radars: [],
  blobSuggestions: [],
  linkings: []
}

// getters
const getters = {
  users (state) {
    return state.users
  },

  radars (state) {
    return state.radars
  },

  blobSuggestions (state) {
    return state.blobSuggestions
  },

  blobSuggestionLinkings (state) {
    return state.linkings
  }
}

// actions
const actions = {

  async loadUsers ({ commit }) {
    commit('addToLoadingQueue', 'admin_load_users',  { root: true });

    return axios.get('/admin/users')
      .then((response) => {
        commit('setUsers', response.data);
        commit('removeFromLoadingQueue', 'admin_load_users',  { root: true });
      })
      .catch((error) => {
        commit('removeFromLoadingQueue', 'admin_load_users',  { root: true });
        commit('error/newError', {
          title: 'error.admin.users.load',
          text: error.response? error.response.data.message || error.message: error.message
        }, { root: true});
      });
  },

  async loadRadars ({ commit }) {
    commit('addToLoadingQueue', 'admin_load_radars',  { root: true });

    return axios.get('/admin/radars')
      .then((response) => {
        commit('setRadars', response.data);
        commit('removeFromLoadingQueue', 'admin_load_radars',  { root: true });
      })
      .catch((error) => {
        commit('removeFromLoadingQueue', 'admin_load_radars',  { root: true });
        commit('error/newError', {
          title: 'error.admin.radars.load',
          text: error.response? error.response.data.message || error.message: error.message
        }, { root: true});
      });
  },

  async loadBlobSuggestion ({ commit }) {
    commit('addToLoadingQueue', 'admin_load_blob_suggestions',  { root: true });

    return axios.get('/admin/blob-suggestions')
      .then((response) => {
        commit('setBlobSuggestions', response.data);
        commit('removeFromLoadingQueue', 'admin_load_blob_suggestions',  { root: true });
      })
      .catch((error) => {
        commit('removeFromLoadingQueue', 'admin_load_blob_suggestions',  { root: true });
        commit('error/newError', {
          title: 'error.admin.users.load',
          text: error.response? error.response.data.message || error.message: error.message
        }, { root: true});
      });
  },

  async loadBlobSuggestionLinkings({ commit }) {
    // set loader
    commit('addToLoadingQueue', 'admin_load_blob_suggestions_linking',  { root: true });

    return axios.get('/admin/blob-linkings')
      .then((response) => {
        commit('setLinkings', response.data);
        commit('removeFromLoadingQueue', 'admin_load_blob_suggestions_linking',  { root: true });
      })
      .catch((error) => {
        commit('removeFromLoadingQueue', 'admin_load_blob_suggestions_linking',  { root: true });
        commit('error/newError', {
          title: 'error.admin.users.load',
          text: error.response? error.response.data.message || error.message: error.message
        }, { root: true});
      });
  },

  /**
   * create blob
   * @param commit
   * @param blob
   * @returns {Promise<unknown>}
   */
  async createBlobSuggestion({ commit }, blob) {
    // set loader
    commit('addToLoadingQueue', 'admin_create_new_blob_suggestions',  { root: true });

    return new Promise((resolve, reject) => {
      // send create request
      axios.post('/admin/blob-suggestions', blob, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          // update radar
          commit('setBlobSuggestion', response.data.blob)

          // remove loader
          commit('removeFromLoadingQueue', 'admin_create_new_blob_suggestions', { root: true });

          resolve(response);
        })
        .catch((error) => {
          // remove loader
          commit('removeFromLoadingQueue', 'admin_create_new_blob_suggestions', { root: true });
          // raise error
          commit('error/newError', {
            title: 'error.blob.create',
            text: error.response? error.response.data.message || error.message: error.message
          }, { root: true});

          reject(error);
        })
    });
  },

  /**
   * update blob
   * @param commit
   * @param blob
   * @returns {Promise<unknown>}
   */
  async updateBlobSuggestion({ commit }, blob) {
    // set loader
    commit('addToLoadingQueue', 'admin_update_blob_suggestions' + blob.id, { root: true });

    return new Promise((resolve, reject) => {
      // send update request
      axios.post('/admin/blob-suggestions/' + blob.get('id'), blob, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          // update blob
          commit('setBlobSuggestion', response.data.blob)
          // remove loader
          commit('removeFromLoadingQueue', 'admin_update_blob_suggestions' + blob.id, {root: true});
          resolve(response);
        })
        .catch((error) => {
          // remove loader
          commit('removeFromLoadingQueue', 'admin_update_blob_suggestions' + blob.id, {root: true});
          // raise error
          commit('error/newError', {
            title: 'error.blob.update',
            text: error.response? error.response.data.message || error.message: error.message
          }, { root: true});

          reject(error);
        })
    });
  },

  /**
   * remove blob
   * @param commit
   * @param blob
   * @returns {Promise<unknown>}
   */
  async removeBlobSuggestion({ commit }, blob) {
    // set loader
    commit('addToLoadingQueue', 'admin_delete_blob_suggestions' + blob.id, { root: true });

    return new Promise((resolve, reject) => {
      // send update request
      axios.delete('/admin/blob-suggestions/' + blob.id)
        .then((response) => {

          // update radar
          commit('removeBlobSuggestion', blob);
          // remove loader
          commit('removeFromLoadingQueue', 'admin_delete_blob_suggestions' + blob.id, {root: true});

          resolve(response);
        })
        .catch((error) => {
          // remove loader
          commit('removeFromLoadingQueue', 'admin_delete_blob_suggestions' + blob.id, {root: true});

          commit('error/newError', {
            title: 'error.blob.delete',
            text: error.response? error.response.data.message || error.message: error.message
          }, { root: true});

          reject(error);
        })
    });
  },
}

// mutations
const mutations = {
  setUsers (state, users) {
    state.users = users
  },

  setRadars (state, radars) {
    state.radars = radars
  },

  setLinkings (state, linkings) {
    state.linkings = linkings
  },

  setBlobSuggestions (state, blobs) {
    state.blobSuggestions = blobs
  },

  /**
   * set/update blob
   * @param state
   * @param blob
   */
  setBlobSuggestion(state, blob) {

    let pos = state.blobSuggestions.findIndex(b => b.id == blob.id)

    if(pos <= -1) {
      state.blobSuggestions.push(blob)
    } else {
      // replace object and stay reactive
      state.blobSuggestions.splice(pos, 1, blob)
    }
  },

  removeBlobSuggestion(state, blob) {
    let pos = state.blobSuggestions.findIndex(b => b.id == blob.id);

    if(pos > -1) {
      state.blobSuggestions.splice(pos, 1);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
